import React, { useRef, useState } from "react";
import { Box, Typography } from "@mui/material";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { ArrowBackIosNew, ArrowForwardIos, Check } from '@mui/icons-material';

const PartnerSlider = ({ slides }) => {
  const [activeSlide, setActiveSlide] = useState(0);
  const sliderRef = useRef(null);

  const settings = {
    centerMode: true,
    centerPadding: "150px",
    slidesToShow: 1,
    infinite: true,
    speed: 400,
    focusOnSelect: true,
    autoplay: true,
    arrows: false,
    dots: true,
    afterChange: (current) => setActiveSlide(current),
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          centerPadding: "150px",
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          centerMode: false,
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          centerMode: false,
          slidesToShow: 1,
          dots: false,
        },
      },
    ],
    customPaging: (i) => (
      <Box
        sx={{
          width: 19,
          height: 19,
          borderRadius: "50%",
          backgroundColor: "#d3d3d3",
          display: "inline-block",
        }}
      />
    ),
    appendDots: (dots) => (
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", bottom:{ lg: '0', xs:'-40px'}}}>
        <button
          onClick={() => sliderRef.current.slickPrev()}
          style={{
            marginRight: "30px",
            cursor: "pointer",
            background: "none",
            border: "none",
            fontSize: "24px",
            fontWeight: 600,
            color: "#F59C1E",
          }}
        >
        <ArrowBackIosNew />
        </button>
        <Box 
            sx={{
            display: {xs: 'none', md: "flex"},
            padding: 0,
            margin: "0px !important",
            "& .slick-active div": {
              backgroundColor: "#F59C1E !important",
            },
          }}
        >{dots}</Box>
        <button
          onClick={() => sliderRef.current.slickNext()}
          style={{
            marginLeft: "30px",
            cursor: "pointer",
            background: "none",
            border: "none",
            fontSize: "24px",
            fontWeight: 600,
            color: "#F59C1E",
          }}
        >
        <ArrowForwardIos />
        </button>
      </Box>
    ),
  };

  return (
    <Box>
      <Slider ref={sliderRef} {...settings}>
        {slides.map((slide, index) => (
          <Box key={index} sx={{ my : { md: index === activeSlide ? 4 : 7, lg:index === activeSlide ? 7 : 10 }, }}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "20px",
                transition: { md: "transform 0.4s ease-in-out, z-index 0.4s ease-in-out" },
                transform: { md: index === activeSlide ? "scale(1.2)" : "scale(0.9)", xs: "none" },
                height: { md: index === activeSlide ? "250px" : "200px", xs: "auto" },
                position: "relative",
                zIndex: index === activeSlide ? 2 : 1,
                overflow: { md: "visible"}
              }}
            >
              <img
                src={slide?.src}
                alt={`Slide ${index + 1}`}
                style={{
                  width: { md:"100%", xs: '80%'},
                  maxWidth: "100%",
                  objectFit: "contain",
                  borderRadius: "15px",
                  boxShadow: { md: index === activeSlide ? "0px 10px 30px rgba(0,0,0,0.2)": "none"},
                  boxShadow: '0px 0px 5px #dddada'
                }}
              />
            </Box>
            {index === activeSlide && (
              <Typography variant="body1" sx={{ mt:{ lg: 3, xs: 2} }}>
                {slide?.tagline}
              </Typography>
            )}
          </Box>
        ))}
      </Slider>
    </Box>
  );
};

export default PartnerSlider;
